import React from 'react'
import Select from 'react-select'
import classnames from 'classnames'

const FONT_SIZE = '0.875rem'
const LINE_HEIGHT = '1.25rem'
const COLOR_WHITE = '#fff'

const OPTION_COLOR = '#8394a3'

const getCustomStyles = (styles = {}) => {
  const defaultStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: '0',
      fontSize: FONT_SIZE,
      lineHeight: LINE_HEIGHT,
      padding: 15,
      cursor: 'pointer',
      color: state.isSelected ? COLOR_WHITE : OPTION_COLOR,
    }),
    control: provided => ({
      ...provided,
      border: 0,
      minHeight: '3.5rem',
      borderRadius: '1.5rem',
      color: COLOR_WHITE,
      padding: '0.25rem 1.5rem',
      fontSize: FONT_SIZE,
      lineHeight: LINE_HEIGHT,
    }),
    input: provided => ({
      color: COLOR_WHITE,
      ...provided,
    }),
    indicatorSeparator: () => ({
      opacity: 0,
    }),
    valueContainer: provided => {
      return { ...provided, padding: 0 }
    },
    menu: provided => {
      return { ...provided, zIndex: 999999 }
    },
    menuList: provided => {
      return { ...provided, padding: 0 }
    },
    multiValue: provided => {
      return { ...provided, backgroundColor: COLOR_WHITE, borderRadius: '0.25rem' }
    },
    noOptionsMessage: () => {
      return { display: 'none' }
    },
  }

  Object.keys(styles).forEach(style => {
    if (!defaultStyles[style]) {
      defaultStyles[style] = styles[style]
    }

    const existingStyle = defaultStyles[style]

    defaultStyles[style] = (provided, state) => ({
      ...existingStyle(provided, state),
      ...styles[style](provided, state),
    })
  })

  return defaultStyles
}

const MultiSelect = ({ name, className, onChange, styles, ...rest }) => {
  const handleChange = values => {
    if (name && onChange) {
      onChange({ name, values })
    }
  }

  return (
    <Select
      isMulti
      className={classnames('basic-multi-select', className)}
      classNamePrefix="select"
      styles={getCustomStyles(styles)}
      onChange={handleChange}
      {...rest}
    />
  )
}

export default MultiSelect
